// eslint-disable-next-line
import React, { useEffect, useMemo } from 'react';
import { message, Menu, Dropdown } from 'antd';
import ShiftAvatar from './shiftAvatar';
import cn from '@/utils/cn';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'appRedux/reducers/ReducerState';
import { cashierGuestChangeOnlineShift, cashierProcessReset } from 'appRedux/actions/cashier/guest';
import styled from 'styled-components';

const StyledShiftMenu = styled(Menu)`
  border-radius: 12px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.2);
  overflow-y: auto;
  max-height: 250px;
  padding: 0 !important;

  .ant-dropdown-menu-item {
    font-weight: 500;
    font-size: 15px;
    color: #1677ff;
    padding: 10px 20px;
    transition:
      background 0.2s,
      color 0.2s;

    &:hover {
      background-color: #cceeff;
      color: #0958d9;
    }
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #91d5ff;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
export const OnlineTag: React.FC = () => {
  const cashierGuest = useSelector((state: AppState) => state.cashierGuest);
  const systemConfig = useSelector((state: AppState) => state.systemConfig);
  const { dataSource: dataSourceConfig } = systemConfig;
  const { process } = cashierGuest;

  const dispatch = useDispatch();

  const WORKING_SHIFT = dataSourceConfig?.SYSTEM?.SHIFTS || [];
  const ONLINE_SHIFT = dataSourceConfig?.SYSTEM?.ONLINE_SHIFT || '';

  const onlineTitle = useMemo(() => {
    return ONLINE_SHIFT.toUpperCase() !== 'X' ? 'Online Shift' : 'Offline';
  }, [ONLINE_SHIFT]);

  const onlineStatus = useMemo(() => {
    return ONLINE_SHIFT.toUpperCase() !== 'X' ? ONLINE_SHIFT.toUpperCase() : '';
  }, [ONLINE_SHIFT]);

  useEffect(() => {
    const action_validate = ['guestChangeOnlineShift'];
    const error_code = ['1', '2', '4', 'ERROR'];
    if (action_validate.includes(process.action)) {
      if (process.status && !error_code.includes(process.result_code))
        message.success(process.message.toString());
      else message.error(process.message.toString());

      setTimeout(() => {
        dispatch(cashierProcessReset());
      }, 100);
    }
  }, [process, dispatch]);

  const menu = () => {
    return (
      <StyledShiftMenu onClick={onHandleChange}>
        {WORKING_SHIFT.map((obj: any) => (
          <Menu.Item key={obj}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <ShiftAvatar
                size={20}
                style={{
                  background: 'linear-gradient(135deg, #52c41a, #73d13d)',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 12,
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                  border: '1px solid #34a853',
                }}
              >
                {obj.toUpperCase()}
              </ShiftAvatar>
              <span>Shift {obj}</span>
            </div>
          </Menu.Item>
        ))}
        <Menu.Item key={'X'}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ShiftAvatar
              size={20}
              style={{
                background: 'linear-gradient(135deg, #ff4d4f, #ff7875)',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 12,
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                border: '1px solid #cf1322',
              }}
            >
              X
            </ShiftAvatar>
            <span>Offline</span>
          </div>
        </Menu.Item>
      </StyledShiftMenu>
    );
  };

  const onHandleChange = (value: any) => {
    dispatch(cashierGuestChangeOnlineShift(value?.key));
  };
  const isOffline = ONLINE_SHIFT.toUpperCase() === 'X';

  return (
    <Dropdown popupRender={() => menu()} placement='bottom' trigger={['click']}>
      <div className={cn(
        'inline-flex items-center justify-center gap-1.5 py-[6px] px-[12px] rounded-full font-[600] text-sm cursor-pointer border shadow-sm transition-colors duration-200 select-none',
        isOffline
          ? 'bg-red-100 border-red-300 text-red-500 hover:bg-red-200'
          : 'bg-[#e6f7ff] border-[#91d5ff] text-[#1890ff] hover:bg-[#bae7ff] hover:border-[#69c0ff]',
      )}>
        <ShiftAvatar
          size={18}
          style={{
            background: isOffline
              ? 'linear-gradient(135deg, #ff4d4f, #ff7875)'
              : 'linear-gradient(135deg, #52c41a, #73d13d)',
            color: '#fff',
            fontSize: 11,
            fontWeight: 'bold',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
            border: isOffline ? '1px solid #cf1322' : '1px solid #34a853',
          }}
        >
          {isOffline ? 'X' : onlineStatus}
        </ShiftAvatar>
        <span className='hidden md:inline-block whitespace-nowrap leading-none'>{onlineTitle}</span>
      </div>
    </Dropdown>
  );
};
export default OnlineTag;
